import React from 'react';
const IconStatusFilter = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.03212 5.14789C3.97958 5.23337 3.99251 5.3434 4.06345 5.41457L10.03 12.557V17.415C10.021 17.4964 10.0569 17.5762 10.124 17.6239L13.4675 19.9662C13.556 20.0113 13.661 20.0113 13.7495 19.9662C13.8417 19.9374 13.9048 19.8532 13.9062 19.7573V12.557L19.9353 5.41457C20.0079 5.34416 20.0209 5.23298 19.9667 5.14789C19.9313 5.05851 19.844 5.00012 19.7473 5.00122H4.28278C4.17596 4.99061 4.07453 5.04996 4.03212 5.14789Z" fill="#666666"/>
</svg>
);
};
export default IconStatusFilter;